(() => {
  const root = document.querySelector('[data-pp-addon]');
  if (!root) return;
  const form = root.querySelector('#pp-addon-form');
  const variants = JSON.parse(root.querySelector('[data-addon-variants]').textContent);
  const variantSelect = form.querySelector('[name="id"]');
  const planSelect = form.querySelector('[name="selling_plan"]');
  const subscribe = form.querySelector('[value="subscribe"]');
  const once = form.querySelector('[value="once"]');
  const submit = form.querySelector('[type="submit"]');
  const mainImage = root.querySelector('#gallery-main-image');
  const thumbs = [...root.querySelectorAll('.thumb')];
  let imageIndex = 0;
  function showImage(index) {
    imageIndex = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[imageIndex];
    if (!thumb) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = thumb.dataset.src;
    mainImage.alt = thumb.dataset.alt;
    thumbs.forEach((item, i) => { item.classList.toggle('active', i === imageIndex); item.setAttribute('aria-current', String(i === imageIndex)); });
    root.querySelector('.gallery-count').textContent = `${imageIndex + 1} / ${thumbs.length}`;
  }
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
  root.querySelector('.gallery-arrow.prev').addEventListener('click', () => showImage(imageIndex - 1));
  root.querySelector('.gallery-arrow.next').addEventListener('click', () => showImage(imageIndex + 1));
  function update(rebuild = false) {
    const variant = variants.find(item => String(item.id) === variantSelect.value);
    if (!variant) return;
    if (rebuild) {
      const selectedPlan = planSelect.value;
      planSelect.replaceChildren(...variant.plans.map(plan => new Option(plan.name, plan.id)));
      if (variant.plans.some(plan => String(plan.id) === selectedPlan)) planSelect.value = selectedPlan;
      if (!variant.plans.length) once.checked = true;
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
      if (variant.image) {
        const index = thumbs.findIndex(thumb => thumb.dataset.src.split('?')[0] === variant.image.split('?')[0]);
        if (index >= 0) showImage(index);
      }
    }
    subscribe.disabled = !variant.plans.length;
    const isSubscription = subscribe.checked && variant.plans.length > 0;
    root.querySelector('#frequency-wrap').hidden = !isSubscription;
    planSelect.disabled = !isSubscription;
    const plan = variant.plans.find(item => String(item.id) === planSelect.value);
    root.querySelector('#once-price').textContent = variant.formatted;
    root.querySelector('#sub-price').textContent = plan ? plan.formatted : '';
    root.querySelector('#product-price').textContent = isSubscription && plan ? plan.formatted : variant.formatted;
    submit.disabled = !variant.available;
    submit.textContent = variant.available ? 'Add to Cart' : 'Sold out';
  }
  variantSelect.addEventListener('change', () => update(true));
  planSelect.addEventListener('change', () => update());
  form.querySelectorAll('[name="purchase_option"]').forEach(input => input.addEventListener('change', () => update()));
  update(true);
  const linkedPlan = new URL(location.href).searchParams.get('selling_plan');
  if (linkedPlan && [...planSelect.options].some(option => option.value === linkedPlan)) {
    planSelect.value = linkedPlan; subscribe.checked = true; update();
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const error = form.querySelector('.addon-error');
    error.hidden = true; submit.disabled = true; submit.textContent = 'Adding…';
    const data = new FormData(form); data.delete('purchase_option');
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (failure) { error.textContent = failure.message; error.hidden = false; update(); }
  });
})();

(()=>{const section=document.getElementById('compatible-models-slider');if(!section)return;const track=section.querySelector('.compare'),prev=section.querySelector('.compatible-prev'),next=section.querySelector('.compatible-next');function update(){prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;}function move(d){const width=track.firstElementChild.getBoundingClientRect().width,gap=parseFloat(getComputedStyle(track).gap)||16;track.scrollBy({left:d*(width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',e=>{if(e.target===track&&(e.key==='ArrowLeft'||e.key==='ArrowRight')){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});new ResizeObserver(update).observe(track);update();})();